import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, empty, TimeoutError, throwError } from 'rxjs';
import { timeout, map, catchError } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from './datastore.service';

@Injectable()
export class HttpInterceptorInterceptor implements HttpInterceptor {
  loadIssue;

  constructor(
    private DataStore: DatastoreService,
    private spinner: NgxSpinnerService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      timeout(60000),
      map(res => {
        return res;
      }),
      catchError(err => {
        console.log(err);
        // /fees must fail loudly: a 404 there means "this cannot be priced" —
        // fees() logs the reason and rethrows so the journey blocks instead of
        // selling an unpriced ceremony at £0. The legacy empty() below would
        // make fees() resolve to undefined and that guard would never fire.
        if (/\/fees(\?|$)/.test(request.url)) {
          this.spinner.hide();
          return throwError(() => err);
        }
        // Payment-setup calls must see the real error: the pre-basket gate
        // answers 409 with a machine-readable reason, and the summary
        // component's recovery flow branches on it. Swallowing it into an
        // empty response (the legacy behaviour below) made a deliberate
        // payment block indistinguishable from a network blip.
        if (request.url.indexOf('/payment/hey-centric/') !== -1) {
          this.spinner.hide();
          return throwError(() => err);
        }
        this.DataStore.onNotify(true)
        this.spinner.hide();
        if (err instanceof TimeoutError) {
          console.error('Timeout has occurred', request.url);
        } return empty();
      })
    );
  }
}
